import { render } from "./ForgotPassword.vue?vue&type=template&id=7c89296e"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ForgotPassword.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_ddf680ab%2Fpackages%2Finsurer%2Fsrc%2Fviews%2FForgotPassword.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__